import {Store} from 'vuex';
import StorageRepository from '@/app/common/repository/StorageRepository';
import ApiService from '@/app/common/service/ApiService';
import IUserInfo from '@/app/common/model/IUserInfo';
import LoginStrategy from '@/app/common/service/LoginStrategy';

export default async (store: Store<any>) => {
  store.commit('setLoadingState', true);
  // localStorage.setItem('recaptcha', '6Le8qbwUAAAAAJ2GbCynDdqP2UsYh-lJ014p3wsb');
  if (StorageRepository.getLicense() && StorageRepository.getToken()) {
    try {
      ApiService.setHeader('License', `License ${StorageRepository.getLicense()}`);
      await store.dispatch('getUserSettings');
      store.commit('saveLicense', {
        license: StorageRepository.getLicense(),
        recaptcha: StorageRepository.getRecaptcha(),
      });
      await store.dispatch('getImagesSettings');
      await store.dispatch('getMenuLogo');
      return LoginStrategy.resolveLoginStrategy(StorageRepository.getUserInfo() as IUserInfo);
    } catch (e) {
      store.commit('setLoadingState', false);
      console.log(e);
    }
  } else {
    await store.dispatch('getLicense');
    await store.dispatch('translate');
    store.commit('setLoadingState', false)
  }
};
